"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllotmentInvoiceListFilter = exports.allotmentInvoiceListFilterConfig = exports.className = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const roundMoney_1 = require("../../../../utils/roundMoney");
const Button_1 = require("../../../Button");
const Multiple_1 = require("../../../CheckBox/Multiple");
const SearchUser_1 = require("../../../Form/Field/SearchUser");
const utils_1 = require("../../../Form/Field/SearchUser/utils");
require("./index.scss");
exports.className = 'allotment-invoice-list-filter';
const allotmentInvoicePaymentStatusLabels = {
    unpaid: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/InvoiceList/Filter:unpaid', defaultMessage: 'Unpaid' })),
    overDeadline: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/InvoiceList/Filter:over', defaultMessage: 'Over payment deadline' })),
    paid: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/InvoiceList/Filter:paid', defaultMessage: 'Paid' })),
};
const allotmentInvoiceListFilterConfig = () => ({
    type: 'object',
    shape: {
        agent: {
            type: 'object',
            optional: true,
        },
        status: {
            type: 'array',
            optional: true,
            items: [
                'unpaid',
                'overDeadline',
                'paid',
            ],
        },
    },
});
exports.allotmentInvoiceListFilterConfig = allotmentInvoiceListFilterConfig;
const AllotmentInvoiceListFilter = (props) => {
    const { field, reset, balance } = props;
    const { locale } = (0, react_intl_1.useIntl)();
    const agentField = field(['agent']);
    return (react_1.default.createElement("div", { className: exports.className },
        react_1.default.createElement(SearchUser_1.SearchUser, { ...agentField, toItem: utils_1.mapAgentToUserItem, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/InvoiceList/Filter:SearchAgent', defaultMessage: 'Search Agent' }), additionClassNames: `${exports.className}__agent-list` }),
        react_1.default.createElement(Multiple_1.CheckBoxMultiple, { ...field(['status']), toItem: (itemValue) => ({
                value: itemValue,
                label: allotmentInvoicePaymentStatusLabels[itemValue],
            }), title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/InvoiceList/Filter:Status', defaultMessage: 'Status:' }) }),
        react_1.default.createElement("div", { className: `${exports.className}__right` },
            balance.outstandingAmount !== undefined && balance.agentName && (react_1.default.createElement("div", { className: `${exports.className}__outstanding-amount` },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/List/Filter:outstandingAmount', defaultMessage: 'Outstanding amount {agent}: {outstandingAmount}', values: {
                        agent: balance.agentName,
                        outstandingAmount: `${(0, roundMoney_1.localizeMoney)(balance.outstandingAmount, locale, 'Allotment/InvoiceList/Filter/outstandingAmount')}  CHF`,
                    } }))),
            react_1.default.createElement(Button_1.Button, { icon: 'cycle', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/List/Filter:ResetButton', defaultMessage: 'Reset' }), onClick: reset, modificators: ['ascetic', 'block'], additionClassNames: `${exports.className}__reset` }))));
};
exports.AllotmentInvoiceListFilter = AllotmentInvoiceListFilter;
//# sourceMappingURL=index.js.map